import {
    StyledCommandMenuList,
    StyledCommandMenuListLoaderBox,
    StyledCommandMenuListResults
} from '@/components/commons/global-search/style'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {useTranslation} from '@/translations/i18n'

export const GlobalSearchLoader = () => {
    const {t} = useTranslation()
    return (
        <StyledCommandMenuList style={{padding: 0}}>
            <ScrollArea scrollbar={<Scrollbar />} style={{height: '100%'}}>
                <StyledCommandMenuListResults>{t('global_search:searching')}</StyledCommandMenuListResults>
                {Array.from({length: 8}).map((_, index) => (
                    <StyledCommandMenuListLoaderBox key={index}>
                        <Skeleton
                            key={index}
                            height={36}
                            width={`calc(100% - ${index * (Math.floor(Math.random() * 50) + 1) + 100}px)`}
                        />
                    </StyledCommandMenuListLoaderBox>
                ))}
            </ScrollArea>
        </StyledCommandMenuList>
    )
}
